import { IInvalidRow } from "./invalid-row";
import { IReconciliationItem } from "./reconciliation-item";

export interface IReconciliation {
    items: IReconciliationItem[],
    invalidRows: IInvalidRow[]
}
